import { memo, useMemo } from 'react';
import { Checkbox, Tooltip } from '@ds';
import { AdminFormRow } from '@ui';
import {
  CUSTOMER_ROLE_ADMIN_NAMES,
  CUSTOMER_ROLE_DESCRIPTIONS,
  CUSTOMER_ROLES_EXCLUSIVE,
} from '@/constants/customer.constants';
import { CustomerRoleOnly } from '@/api/apis/customer';
import { getCustomerRoleNames, getNameValuesFromEnumNames } from '@/utils/helpers';
import { ControlledCheckboxGroup } from '../components/inputs/ControlledCheckboxGroup';

export type RoleSelectorProps = {
  name: string;
  roleValues: CustomerRoleOnly[];
  handleRoleChange: (newRoles: string[]) => void;
  isReadOnly?: boolean;
};

export const RoleSelector = memo(({ name, roleValues, handleRoleChange, isReadOnly = false }: RoleSelectorProps) => {
  const adminRoleList = useMemo(() => getNameValuesFromEnumNames(CUSTOMER_ROLE_ADMIN_NAMES), []);
  const displayedRoles = useMemo(() => getCustomerRoleNames(undefined, adminRoleList), [adminRoleList]);

  return (
    <AdminFormRow title="Role" isRequired inputWrapperClass="max-w-240">
      <ControlledCheckboxGroup
        name={name}
        orientation="horizontal"
        value={roleValues}
        onChange={handleRoleChange}
        isDisabled={isReadOnly}
      >
        {displayedRoles.map((item) => (
          <Tooltip
            className="text-m-r!"
            content={<div className="max-w-[320px]">{CUSTOMER_ROLE_DESCRIPTIONS[item.value]}</div>}
            showArrow
            key={item.value}
          >
            <Checkbox size="md" value={item.value} className="p-0 m-2" isDisabled={isReadOnly}>
              <div className="flex flex-col">
                {item.name}
                {CUSTOMER_ROLES_EXCLUSIVE.includes(item.value) && (
                  <span className="text-xs text-base-20">not combinable with other roles</span>
                )}
              </div>
            </Checkbox>
          </Tooltip>
        ))}
      </ControlledCheckboxGroup>
    </AdminFormRow>
  );
});
